/* BabyBoss Cart Gift Offer — attribute-based.
 * Pairs with snippets/bb-cart-gift-offer.liquid.
 * Cloned from Heny's approved gift picker, adapted to the BabyBoss theme.
 * Gifts are written to cart.attributes (not as line items).
 *
 * BabyBoss theme dispatches no cart events; the drawer body (#CartDrawer-Body)
 * and the cart page items (cart-items) are innerHTML-replaced by cart.js after
 * every change, so the gift block re-renders server-side automatically.
 * A MutationObserver on those roots drives the stale-attribute cleanup.
 *
 * iOS Safari does not always synthesize click events for taps when the only
 * listener is delegated on document. Every interactive element therefore ALSO
 * gets a direct listener (re-bound after each re-render); the delegated
 * listener remains as a fallback and skips directly-bound elements.
 */
(function () {
  if (window.__bbGiftOfferBound) return;
  window.__bbGiftOfferBound = true;

  var T1_THRESHOLD = 60000;
  var T2_THRESHOLD = 100000;
  var T1_KEY = 'מתנה ראשונה (₪600+)';
  var T2_KEY = 'מתנה שנייה (₪1,000+)';
  var ACT_SEL = '[data-bb-go-toggle],[data-bb-go-swap],[data-bb-go-pick]';

  function onCartPage() {
    try {
      if (window.location && window.location.pathname.indexOf('/cart') === 0) return true;
    } catch (e) {}
    return false;
  }

  /* Refresh the whole drawer body from the server (same mechanism the theme
   * itself uses). Safer than swapping a single element: the gift block can
   * never be orphaned or accidentally removed. */
  function swapSnippet() {
    return fetch('/?sections=cart-drawer', { cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (sections) {
        if (!sections || !sections['cart-drawer']) return;
        var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
        var freshBody = doc.querySelector('#CartDrawer-Body');
        var liveBody = document.querySelector('#CartDrawer-Body');
        if (freshBody && liveBody) {
          liveBody.innerHTML = freshBody.innerHTML;
        } else {
          // Fallback: swap only the gift wrap, never remove it
          var fresh = doc.querySelector('[data-bb-gift-offer]');
          if (!fresh) return;
          document.querySelectorAll('[data-bb-gift-offer]').forEach(function (live) {
            live.outerHTML = fresh.outerHTML;
          });
        }
        bindDirect();
      })
      .catch(function () {});
  }

  function refreshCart() {
    if (onCartPage()) {
      window.location.reload();
      return;
    }
    swapSnippet();
  }

  function cartGet() {
    return fetch('/cart.js', { cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  function updateAttributes(attrs) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: attrs })
    });
  }

  /** Auto-clear a gift attribute when its threshold is no longer met. */
  function autoRemoveStaleAttributes() {
    return cartGet().then(function (cart) {
      var newAttrs = {};
      var needsUpdate = false;
      var attrs = cart.attributes || {};
      if (attrs[T1_KEY] && cart.total_price < T1_THRESHOLD) {
        newAttrs[T1_KEY] = '';
        needsUpdate = true;
      }
      if (attrs[T2_KEY] && cart.total_price < T2_THRESHOLD) {
        newAttrs[T2_KEY] = '';
        needsUpdate = true;
      }
      if (!needsUpdate) return { removed: false, cart: cart };
      return updateAttributes(newAttrs).then(function () { return { removed: true, cart: cart }; });
    }).catch(function () { return { removed: false, cart: null }; });
  }


  /* ===== HEBREW TRANSLATION of Shopify's English-only cart errors =====
   * Shopify returns availability errors in English regardless of the
   * storefront locale (verified). Swap known patterns to Hebrew wherever
   * they render inside the cart drawer / cart page. */
  var ERR_PATTERNS = [
    [/Only (\d+) items? (?:was|were) added to your cart due to availability\.?/, function (n) {
      return n === '1' ? 'נוספה רק יחידה אחת לעגלה, זו הכמות שיש כרגע במלאי.'
                       : 'נוספו רק ' + n + ' יחידות לעגלה, זו הכמות שיש כרגע במלאי.';
    }],
    [/All (\d+) items? (?:is|are) in your cart\.?/, function (n) {
      return n === '1' ? 'היחידה האחרונה שבמלאי כבר נמצאת בעגלה.'
                       : 'כל ' + n + ' היחידות שבמלאי כבר בעגלה.';
    }]
  ];
  function translateCartErrors() {
    var scopes = [document.getElementById('CartDrawer-Body'),
                  document.querySelector('cart-items'),
                  document.getElementById('cart-errors'),
                  document.querySelector('.cart-drawer')];
    scopes.forEach(function (scope) {
      if (!scope) return;
      var walker = document.createTreeWalker(scope, NodeFilter.SHOW_TEXT);
      var nodes = [];
      while (walker.nextNode()) nodes.push(walker.currentNode);
      nodes.forEach(function (tn) {
        var t = tn.textContent;
        ERR_PATTERNS.forEach(function (pair) {
          var m = t.match(pair[0]);
          if (m) t = t.replace(pair[0], pair[1](m[1]));
        });
        if (t !== tn.textContent) tn.textContent = t;
      });
    });
  }

  /* ===== ACTIVATION (shared by direct + delegated listeners) ===== */
  function activate(el) {
    if (el.hasAttribute('data-bb-go-toggle')) {
      var picker = el.closest('[data-bb-go-picker]');
      if (!picker) return;
      var opts = picker.querySelector('[data-bb-go-opts]');
      if (!opts) return;
      var isOpen = !opts.hasAttribute('hidden');
      if (isOpen) {
        opts.setAttribute('hidden', '');
        picker.classList.remove('bb-go--open');
      } else {
        opts.removeAttribute('hidden');
        picker.classList.add('bb-go--open');
        setTimeout(function () {
          try { opts.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
        }, 60);
      }
      return;
    }

    // Swap — purely client-side: hide DONE, show PICKER open. No server call
    // until a new variant is picked.
    if (el.hasAttribute('data-bb-go-swap')) {
      var block = el.closest('[data-bb-go-block]');
      if (!block) return;
      var done = block.querySelector('[data-bb-go-done]');
      var pk = block.querySelector('[data-bb-go-picker]');
      if (done) done.style.display = 'none';
      if (pk) {
        pk.classList.remove('bb-go--initially-hidden');
        pk.style.display = '';
        var opts2 = pk.querySelector('[data-bb-go-opts]');
        if (opts2) {
          opts2.removeAttribute('hidden');
          pk.classList.add('bb-go--open');
          setTimeout(function () {
            try { opts2.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); } catch (e) {}
          }, 80);
        }
      }
      return;
    }

    if (el.hasAttribute('data-bb-go-pick')) {
      if (el.disabled) return;
      var title = el.getAttribute('data-variant-title');
      var tier = parseInt(el.getAttribute('data-tier'), 10) || 1;
      if (!title) {
        console.error('[bb-go] pick: missing variant title');
        return;
      }
      var pickerEl = el.closest('.bb-go--picker');
      if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = true; });
      el.style.opacity = '0.6';
      var attrs = {};
      attrs[tier === 2 ? T2_KEY : T1_KEY] = title;
      updateAttributes(attrs)
        .then(function (r) {
          if (!r.ok) {
            return r.text().then(function (txt) { throw new Error('update failed ' + r.status + ': ' + txt); });
          }
          return r.json();
        })
        .then(function () {
          refreshCart();
        })
        .catch(function (err) {
          console.error('[bb-go] update failed', err);
          if (pickerEl) pickerEl.querySelectorAll('button').forEach(function (b) { b.disabled = false; });
          el.style.opacity = '';
          alert('שגיאה בשמירת הבחירה. נסי שוב.');
        });
    }
  }

  /* ===== DIRECT BINDING (iOS-safe) — re-applied after every re-render ===== */
  function bindDirect() {
    document.querySelectorAll(ACT_SEL).forEach(function (el) {
      if (el.__bbGoBound) return;
      el.__bbGoBound = true;
      el.addEventListener('click', function (e) {
        e.preventDefault();
        activate(el);
      });
    });
  }

  /* ===== DELEGATED FALLBACK =====
   * Handles only elements that do NOT yet carry their own listener (e.g. a tap
   * that lands between a re-render and the next bindDirect). It must never set
   * __bbGoBound: doing so made bindDirect skip the element later, leaving it
   * with no listener at all and permanently dead to taps. */
  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    var t = e.target.closest(ACT_SEL);
    if (!t || t.__bbGoBound) return;
    e.preventDefault();
    activate(t);
  }, true); /* capture: fires before any stopPropagation in the theme's handlers */

  /* ===== CART CHANGE DETECTION via MutationObserver ===== */
  var debounceTimer = null;
  var inFlight = false;
  function onCartChanged() {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(function () {
      if (inFlight) return;
      inFlight = true;
      autoRemoveStaleAttributes()
        .then(function (res) {
          inFlight = false;
          if (res.removed) return swapSnippet();
          // Self-heal: if the theme's re-render dropped the gift wrap while
          // the cart still has items (e.g. an over-stock error render),
          // restore it with a full server re-render.
          var body = document.getElementById('CartDrawer-Body');
          if (body && res.cart && res.cart.item_count > 0 && !document.querySelector('[data-bb-gift-offer]')) {
            return swapSnippet();
          }
        })
        .catch(function () { inFlight = false; });
    }, 200);
  }

  function observe() {
    /* Body-wide, bind-only watcher: survives the drawer node being replaced
     * wholesale. Must stay free of DOM writes or it would re-trigger itself. */
    if (document.body) {
      /* Coalesced to one pass per frame: sliders and lazy images fire mutations
       * constantly, and an unthrottled querySelectorAll on each one is a real
       * drag on low-end phones. */
      var bindQueued = false;
      new MutationObserver(function () {
        if (bindQueued) return;
        bindQueued = true;
        requestAnimationFrame(function () { bindQueued = false; bindDirect(); });
      }).observe(document.body, { childList: true, subtree: true });
    }

    var targets = [];
    var drawerBody = document.getElementById('CartDrawer-Body');
    if (drawerBody) targets.push(drawerBody);
    var cartItems = document.querySelector('cart-items');
    if (cartItems) targets.push(cartItems);
    if (targets.length === 0) return;
    var mo = new MutationObserver(function () {
      bindDirect();
      translateCartErrors();
      onCartChanged();
    });
    targets.forEach(function (t) { mo.observe(t, { childList: true, subtree: true }); });
  }

  /* ===== iOS-safe body scroll lock while the drawer is open =====
   * CSS :has() needs iOS 15.4+; this JS fallback works everywhere.
   * Locks body with position:fixed (preserving scroll), restores on close. */
  (function () {
    var lockedScrollY = null;
    var touchOnly = window.matchMedia && window.matchMedia('(hover: none)').matches;
    if (!touchOnly) return;
    var drawerEl = document.querySelector('cart-drawer');
    if (!drawerEl) return;
    function lock() {
      if (lockedScrollY !== null) return;
      lockedScrollY = window.pageYOffset || document.documentElement.scrollTop || 0;
      document.body.style.position = 'fixed';
      document.body.style.top = (-lockedScrollY) + 'px';
      document.body.style.left = '0';
      document.body.style.right = '0';
      document.body.style.width = '100%';
    }
    function unlock() {
      if (lockedScrollY === null) return;
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.left = '';
      document.body.style.right = '';
      document.body.style.width = '';
      window.scrollTo(0, lockedScrollY);
      lockedScrollY = null;
    }
    var mo = new MutationObserver(function () {
      if (drawerEl.classList.contains('is-visible')) lock();
      else unlock();
    });
    mo.observe(drawerEl, { attributes: true, attributeFilter: ['class'] });
    if (drawerEl.classList.contains('is-visible')) lock();
  })();

  /* ===== INITIAL CHECK ===== */
  function init() {
    observe();
    bindDirect();
    translateCartErrors();
    autoRemoveStaleAttributes().then(function (res) {
      if (res.removed) swapSnippet();
    });
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
